import { imageField } from 'molecules/Image/config';

import type { Input } from '@builder.io/sdk';

export const textWithForegroundImageSwitchback = [
  {
    name: 'backgroundColor',
    type: 'string',
    enum: ['blue', 'gray', 'teal', 'white', 'lightgray', 'ash', 'darkash', 'carbon', 'wgray80', 'greige'],
    defaultValue: 'white',
  },
  {
    name: 'heading',
    type: 'string',
  },
  {
    name: 'body',
    type: 'richText',
  },
  {
    name: 'subContent',
    type: 'object',
    subFields: [
      {
        name: 'title',
        type: 'string',
      },
      {
        name: 'body',
        type: 'richText',
      },
    ],
  },
  imageField('foregroundImage'),
] as const satisfies DeepReadonly<Input[]>;

const textWithForegroundImageSwitchbackConfig = {
  name: 'Text With Foreground Image Switchback',
  inputs: textWithForegroundImageSwitchback,
};

export type TextWithForeGroundImageSwitchbackProps = GenerateBuilder<typeof textWithForegroundImageSwitchback>;

export default textWithForegroundImageSwitchbackConfig;
